import { render, staticRenderFns } from "./HeaderHomeTwo.vue?vue&type=template&id=35b56dea"
import script from "./HeaderHomeTwo.vue?vue&type=script&lang=js"
export * from "./HeaderHomeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports